import type { ReactNode } from 'react';

interface SectionHeadProps {
  label: string;
  action?: ReactNode;
}

export function SectionHead({ label, action }: SectionHeadProps): JSX.Element {
  return (
    <div className="rx-sectionhead">
      <span className="rx-sectionhead-label">{label}</span>
      {action && <span className="rx-sectionhead-action">{action}</span>}
    </div>
  );
}
